import storage, { EStorageKey } from '@webtrader/core/storage';
import { checkIsNative } from '@webtrader/core/validators/device';

export const getMarketingPageUrl = (attributionLink?: string | null): string | undefined => {
  if (attributionLink) {
    return attributionLink;
  }
  if (checkIsNative()) {
    const marketingParams = storage.getItem(EStorageKey.MARKETING_PARAMS);
    return marketingParams ? `aqxtrader://${marketingParams}` : undefined;
  } else {
    return `${window.location.origin}${window.location.pathname}${
      storage.getItem<string>(EStorageKey.MARKETING_PARAMS) || ''
    }`;
  }
};
